"use strict";
exports.__esModule = true;
exports.loadScript = void 0;
function loadScript(_a, updateProps) {
    var src = _a.src, initIntercomWindow = _a.initIntercomWindow, initWindow = _a.initWindow, _b = _a.scriptType, scriptType = _b === void 0 ? "async" : _b, callBack = _a.callBack;
    var intercomLoaded = document.querySelector("script[src=\"" + src + "\"]");
    if (!intercomLoaded) {
        var intercomScript = document.createElement("script");
        intercomScript.type = "text/javascript";
        if (typeof scriptType !== "undefined") {
            intercomScript[scriptType] = true;
        }
        intercomScript.src = src;
        var scripts = document.getElementsByTagName("script");
        var initialScript = (scripts === null || scripts === void 0 ? void 0 : scripts.length) ? scripts[0] : null;
        if (intercomScript) {
            (initialScript === null || initialScript === void 0 ? void 0 : initialScript.parentNode)
                ? initialScript.parentNode.insertBefore(intercomScript, initialScript)
                : document.body.appendChild(intercomScript);
        }
        if (initWindow && updateProps) {
            initIntercomWindow(updateProps);
        }
    }
    else {
        console.error("intercom script already inserted");
    }
    typeof callBack === "function" && callBack();
}
exports.loadScript = loadScript;
//# sourceMappingURL=load-script.js.map